import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
const compact = require('lodash/compact');
const sortBy = require('lodash/sortBy');

import AccessibleIcon from '../common/AccessibleIcon';
import WithOrganizationIntegrationTags from '../DataHOCs/WithOrganizationIntegrationTags';
import TagListItem from './TagListItem';

const propTypes = {
    className: PropTypes.string,
    tags: PropTypes.array,
    onDeleteTag: PropTypes.func.isRequired,
    onNewTagAdd: PropTypes.func.isRequired,
    pendingAddNewTag: PropTypes.bool,
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orgIntegrationTags: PropTypes.array.isRequired,
};

const defaultProps = {
    className: '',
    tags: [],
    pendingAddNewTag: false
};

class TagEditorList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newTag: null,
            tagFilter: '',
        };

        this.onNewTagChange = this.onNewTagChange.bind(this);
        this.onNewTagAdd = this.onNewTagAdd.bind(this);
        this.onTagFilterChange = this.onTagFilterChange.bind(this);
    }

    onNewTagChange(tagId) {
        this.setState({ newTag: this.props.orgIntegrationTags.find(t => t.id === tagId) });
    }

    onNewTagAdd() {
        this.props.onNewTagAdd(this.state.newTag);
        this.setState({ newTag: null, tagFilter: '' });
    }

    onTagFilterChange(e) {
        this.setState({ tagFilter: e.target.value });
    }

    render() {
        const self = this;
        let filteredTags = this.props.tags;
        if (!!this.state.tagFilter) {
            filteredTags = this.props.tags.filter((activeTag) => {
                const tagRecord = this.props.orgIntegrationTags.find(t => t.tag === activeTag.tag);
                return (
                    activeTag.tag.indexOf(this.state.tagFilter) >= 0
                    || (
                        !!tagRecord
                        && !!tagRecord.description
                        && tagRecord.description.toLowerCase().indexOf(this.state.tagFilter) >= 0
                    )
                );
            });
        }

        const sortedFilteredTags = sortBy(filteredTags, t => t.tag.toLowerCase());

        let triggerContent = 'Select tag by name...';
        const sortedAvailableTags = sortBy(this.props.orgIntegrationTags, tagRecord => tagRecord.tag.toLowerCase());
        const menuWidthClasses = 'min-width-200px max-width-300px'; // apply this at multiple levels in menu (ie11 overflow fix)
        const integrationTags = compact(sortedAvailableTags.map((tagRecord) => {
            if (self.props.tags.find(t => t.tag === tagRecord.tag)) { // remove already-in-use tags
                return null;
            }

            let itemClass = 'AriaMenuButton-menuItem';
            if (!!self.state.newTag && self.state.newTag.id === tagRecord.id) {
                itemClass += ' is-selected';
                triggerContent = (
                    <div className="termListing--noBorder">
                        <div className={`termListing__termContainer ${menuWidthClasses}`}>
                            {tagRecord.tag}
                            {!!tagRecord &&
                                <div className="termDescription margin-top-sm">
                                    {tagRecord.description}
                                </div>
                            }
                        </div>
                    </div>
                );
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={tagRecord.id}>
                    <MenuItem
                        className={itemClass}
                        value={tagRecord.id}
                        text={tagRecord.tag}
                    >
                        <div className="termListing--noBorder">
                            <div className={`termListing__termContainer ${menuWidthClasses}`}>
                                {tagRecord.tag}
                                {!!tagRecord &&
                                    <div className="termDescription margin-top-sm">
                                        {tagRecord.description}
                                    </div>
                                }
                            </div>
                        </div>
                    </MenuItem>
                </li>
            );
        }));

        if (integrationTags.length === 0) { // all available tags are in use or no tags exist
            integrationTags.push((
                <li className='AriaMenuButton-menuItemWrapper' key="tag-none">
                    <MenuItem
                        className="AriaMenuButton-menuItem"
                        value=""
                        text="No tags available"
                    >
                        <em className="font-style-italic">No tags available</em>
                    </MenuItem>
                </li>
            ));
        }

        return (
            <div className={this.props.className}>
                <div className="rightAlignRow">
                    <input
                        onChange={this.onTagFilterChange}
                        value={this.state.tagFilter}
                        placeholder="Search"
                    />
                </div>
                <ul>
                    {sortedFilteredTags.map(activeTagRecord => {
                        const tagRecord = this.props.orgIntegrationTags.find(t => t.tag === activeTagRecord.tag);
                        return (
                            <TagListItem
                                key={tagRecord.id}
                                tagRecord={tagRecord}
                                onDeleteTag={this.props.onDeleteTag.bind(null, tagRecord)}
                            />
                        );
                    })}
                    {sortedFilteredTags.length === 0 && this.state.tagFilter &&
                        <li className="termListing--noBorderSpaceAround" key="none-found">
                            <div className="termListing__termContainer">
                                <em className="font-style-italic">
                                    No matching tags found
                                </em>
                            </div>
                        </li>
                    }
                    {sortedFilteredTags.length === 0 && !this.state.tagFilter &&
                        <li className="termListing--noBorderSpaceAround" key="none-found">
                            <div className="termListing__termContainer">
                                <em className="font-style-italic">
                                    No tags in use
                                </em>
                            </div>
                        </li>
                    }
                    <li className="termListing--noBorder" key="newTag">
                        <div className="termListing__termContainer">
                            <Wrapper
                            id="act-int-tags"
                            className="AriaMenuButton"
                            onSelection={this.onNewTagChange}
                            >
                                <Button className={`AriaMenuButton-trigger--flex1 ${menuWidthClasses}`}>
                                    {triggerContent}
                                </Button>
                                <Menu>
                                    <ul className='AriaMenuButton-menu'>
                                        {integrationTags}
                                    </ul>
                                </Menu>
                            </Wrapper>
                        </div>
                        <button
                        className="bare-text-button glyph termListing__control"
                        disabled={this.props.pendingAddNewTag || !this.state.newTag}
                        onClick={this.onNewTagAdd}>
                            <AccessibleIcon
                            label="Add">
                                <span className="fa fa-plus" aria-hidden={true}/>
                            </AccessibleIcon>
                        </button>
                    </li>
                </ul>
            </div>
        );
    }
}

TagEditorList.propTypes = propTypes;
TagEditorList.defaultProps = defaultProps;

export default WithOrganizationIntegrationTags(TagEditorList);